import React from "react";
import { Link } from "react-router-dom";

const footerSections = [
  {
    label: "Product",
    links: [
      { label: "Taskyとは", href: "#features" },
      { label: "実績", href: "#gallery" },
      { label: "料金", href: "#pricing" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    label: "Company",
    links: [
      { label: "利用規約", href: "/legal/terms.html" },
      { label: "プライバシーポリシー", href: "/legal/privacy.html" },
      { label: "特定商取引法に基づく表記", href: "/legal/tokushoho.html" },
    ],
  },
  {
    label: "Contact",
    links: [
      { label: "無料トライアル", href: "/signup" },
      { label: "お問い合わせ", href: "#cta" },
    ],
  },
];

function FooterLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) {
  const className =
    "block text-[13px] text-white/70 hover:text-white transition-colors no-underline";
  if (href.startsWith("/")) {
    return (
      <Link to={href} className={className}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} className={className}>
      {children}
    </a>
  );
}

const LPFooter: React.FC = () => {
  return (
    <footer className="bg-[#1D1927] text-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-20 pt-16 pb-8 lg:pt-20">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-16 mb-12">
          {footerSections.map((section) => (
            <div key={section.label}>
              <p className="text-[11px] font-semibold tracking-[0.12em] uppercase text-white/40 mb-5">
                {section.label}
              </p>
              <div className="space-y-3">
                {section.links.map((link) => (
                  <FooterLink key={link.label} href={link.href}>
                    {link.label}
                  </FooterLink>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/10">
          <Link to="/" className="no-underline">
            <img
              src={`${process.env.PUBLIC_URL}/lp/logos/logo-white.png`}
              alt="Tasky"
              className="h-9"
              loading="lazy"
            />
          </Link>
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} Richka, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LPFooter;
